import { formatRemaining, remainingUntil } from "@/lib/urgency";
import { useNowTick } from "@/hooks/useUrgency";

/**
 * Live countdown to a real end time. Fixed-width digits so nothing shifts
 * as the clock ticks. Renders nothing when there is no end time.
 */
export function UrgencyCountdown({
  endsAt,
  className = "",
  prefix,
}: {
  endsAt: string | null;
  className?: string;
  prefix?: string;
}) {
  const now = useNowTick(Boolean(endsAt));
  const r = remainingUntil(endsAt, now);
  if (!r || r.expired) return null;
  return (
    <span className={`whitespace-nowrap tabular-nums ${className}`}>
      {prefix ? `${prefix} ` : null}
      {formatRemaining(r)}
    </span>
  );
}
